import "../../styles/NotificationPreview.css";

const NotificationPreview = ({ form }) => {

    return (

        <div className="notification-preview">

            <h3>Live Preview</h3>

            <div className="phone-preview">

                <div className="notification-card-preview">

                    <strong>
                        {form.title || "Notification Title"}
                    </strong>

                    <p>
                        {form.message ||
                            "Notification message will appear here..."}
                    </p>

                </div>

            </div>

        </div>

    );

};

export default NotificationPreview;